import { render, staticRenderFns } from "./Imports.vue?vue&type=template&id=32cc1db8&"
import script from "./Imports.vue?vue&type=script&lang=js&"
export * from "./Imports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32cc1db8')) {
      api.createRecord('32cc1db8', component.options)
    } else {
      api.reload('32cc1db8', component.options)
    }
    module.hot.accept("./Imports.vue?vue&type=template&id=32cc1db8&", function () {
      api.rerender('32cc1db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Imports.vue"
export default component.exports